const getParamName = (flow) => `is${flow}DrawerOpen`;
export const SET_DRAWER_STATE = 'SET_DRAWER_STATE';

export const FILTERS_DRAWER = getParamName('Filters');
export const TRANSACTIONS_FILTERS_DRAWER = getParamName('TransactionsFilters');

export const MARKET_VIEW_FILTERS_DRAWER = getParamName('MarketViewFilters');
